import { useState } from 'react';
import ListingPreviewModal from '../../../components/ListingPreview/ListingPreviewModal';
import {
    getDisplay,
    getEditButtonLabel,
    getStatusPillMeta,
    showEditButton,
} from '../groupings';
import { isBulkDraftListing } from './drawerEditHelpers';
import { toPreviewProps } from './previewAdapter';

const PencilIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    </svg>
);

const EyeIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

export default function DrawerHeader({
    listing,
    onClose,
    editMode,
    onRequestEdit,
    onCancelEdits,
}) {
    const [previewOpen, setPreviewOpen] = useState(false);
    const { name, type, address } = getDisplay(listing);
    const statusMeta = getStatusPillMeta(listing);
    const isBulkDraft = isBulkDraftListing(listing);
    const canEdit = showEditButton(listing);
    const bulkEditing = editMode && isBulkDraft;

    const handleEditClick = () => {
        if (bulkEditing) {
            onCancelEdits?.();
            return;
        }
        onRequestEdit?.();
    };

    const handlePreview = () => {
        if (editMode) return;
        setPreviewOpen(true);
    };

    return (
        <>
            <header className="host-panel-head">
                <div className="host-panel-head-row">
                    <div className="host-panel-head-meta">
                        <h3 id="property-drawer-title">{name}</h3>
                        <div className="host-panel-head-sub">
                            <span className={`status-pill ${statusMeta.className}`}>
                                {statusMeta.label}
                            </span>
                            {' '}
                            {address}
                            {type ? ` · ${type}` : ''}
                        </div>
                    </div>
                    <div className="host-panel-head-actions">
                        <button
                            type="button"
                            className="host-panel-close"
                            onClick={onClose}
                            aria-label="Close drawer"
                        >
                            ×
                        </button>
                    </div>
                </div>
                <div className="host-panel-controls">
                    {canEdit && isBulkDraft && (
                        <button
                            type="button"
                            className={`host-edit-toggle${bulkEditing ? ' active' : ''}`}
                            onClick={handleEditClick}
                            title={bulkEditing ? 'Currently editing' : undefined}
                        >
                            <PencilIcon />
                            <span>{getEditButtonLabel(listing, bulkEditing)}</span>
                        </button>
                    )}
                    <button
                        type="button"
                        className={`host-preview-toggle${editMode ? ' disabled' : ''}`}
                        onClick={handlePreview}
                        aria-disabled={editMode ? 'true' : undefined}
                        title={editMode ? 'Cancel edit to preview' : undefined}
                    >
                        <EyeIcon />
                        <span>Preview as listing</span>
                    </button>
                </div>
            </header>
            {previewOpen && (
                <ListingPreviewModal
                    onClose={() => setPreviewOpen(false)}
                    {...toPreviewProps(listing)}
                />
            )}
        </>
    );
}
